
import React, { useState } from 'react';
import { Container, Row, Col, Card, Table, Button } from 'react-bootstrap';
import { 
  Milk, 
  Truck, 
  Calendar, 
  IndianRupee, 
  CheckCircle, 
  Clock,
  CreditCard,
  QrCode,
  Bell,
  Search,
  Menu
} from 'lucide-react';
import MyLayout from '../../../layouts/customer/MyLayout';
// import '../../../components/customer/Home/CustomerDashboard.css';
import '../../../assets/styles/customer/CustomerDashboard.css';

const CustomerDashboard = () => {
  const [searchQuery, setSearchQuery] = useState('');

  // Dummy data for stats
  const statsData = [
    {
      id: 1,
      title: 'Active Plan',
      value: '1L / Day',
      subtitle: 'Full Cream Milk',
      icon: Milk,
      color: 'blue',
      bgColor: '#e3f2fd'
    },
    {
      id: 2,
      title: "Today's Delivery",
      value: 'Delivered',
      subtitle: '6:15 AM',
      icon: Truck,
      color: 'green',
      bgColor: '#e8f5e9'
    },
    {
      id: 3,
      title: 'This Month',
      value: '8 / 10',
      subtitle: 'Days delivered',
      icon: Calendar,
      color: 'orange',
      bgColor: '#fff3e0'
    },
    {
      id: 4,
      title: 'Pending Amount',
      value: '1000',
      subtitle: 'Due: Feb 28',
      icon: IndianRupee,
      color: 'purple',
      bgColor: '#f3e5f5'
    }
  ];

  // Dummy data for recent orders
  const recentOrders = [
    {
      orderId: '#ORD-1024',
      date: 'Feb 15, 2026',
      qty: '1L',
      amount: '180',
      status: 'Delivered'
    },
    {
      orderId: '#ORD-1023',
      date: 'Feb 14, 2026',
      qty: '1L',
      amount: 'RS 180',
      status: 'Delivered'
    },
    {
      orderId: '#ORD-1022',
      date: 'Feb 13, 2026',
      qty: '0.5L',
      amount: '₹80',
      status: 'Delivered'
    },
    {
      orderId: '#ORD-1021',
      date: 'Feb 12, 2026',
      qty: '1L',
      amount: '₹180',
      status: 'Delivered'
    }
  ];

  // Payment summary data
  const paymentSummary = {
    totalThisMonth: '1000',
    paid: '₹700',
    pending: '₹300',
    lastPayment: 'Feb 5, 2026'
  };

  return (
    <MyLayout>
    <div className="customer-dashboard-wrapper">
      {/* Header */}
      <div className="customer-dashboard-header">
        <Container fluid>
          <Row className="align-items-center">
            <Col>
              <div className="customer-dashboard-header-left">
                <button className="customer-dashboard-menu-btn">
                  <Menu size={24} />
                </button>
                <div className="customer-dashboard-title-section">
                  <h1 className="customer-dashboard-page-title">Dashboard</h1>
                  <p className="customer-dashboard-welcome-text">Welcome back, Rahul! 👋</p>
                </div>
              </div>
            </Col>
            <Col xs="auto">
              <div className="customer-dashboard-header-right">
                <div className="customer-dashboard-search-wrapper">
                  <Search className="customer-dashboard-search-icon" size={20} />
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="customer-dashboard-search-input"
                  />
                </div>
                <button className="customer-dashboard-notification-btn">
                  <Bell size={20} />
                  <span className="customer-dashboard-notification-badge">3</span>
                </button>
                <div className="customer-dashboard-user-avatar">
                  <span>R</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Main Content */}
      <div className="customer-dashboard-content">
        <Container fluid>
          {/* Stats Cards */}
          <Row className="customer-dashboard-stats-row">
            {statsData.map((stat, index) => (
              <Col xs={12} sm={6} lg={3} key={stat.id} className="customer-dashboard-stat-col">
                <Card 
                  className="customer-dashboard-stat-card"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <Card.Body>
                    <div className="customer-dashboard-stat-header">
                      <div 
                        className="customer-dashboard-stat-icon-wrapper"
                        style={{ backgroundColor: stat.bgColor }}
                      >
                        <stat.icon 
                          className={`customer-dashboard-stat-icon customer-dashboard-stat-icon-${stat.color}`} 
                          size={24} 
                        />
                      </div>
                      <span className="customer-dashboard-stat-title">{stat.title}</span>
                    </div>
                    <div className="customer-dashboard-stat-content">
                      <h3 className={`customer-dashboard-stat-value customer-dashboard-stat-value-${stat.color}`}>
                        {stat.value}
                      </h3>
                      <p className="customer-dashboard-stat-subtitle">{stat.subtitle}</p>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {/* QR Code Card */}
          <Row className="mt-4">
            <Col xs={12}>
              <Card className="customer-dashboard-qr-card">
                <Card.Body>
                  <Row className="align-items-center">
                    <Col xs={12} md={8}>
                      <div className="customer-dashboard-qr-content">
                        <div className="customer-dashboard-qr-icon-wrapper">
                          <QrCode size={32} />
                        </div>
                        <div>
                          <h4 className="customer-dashboard-qr-title">Scan QR Code</h4>
                          <p className="customer-dashboard-qr-description">
                            Show this QR code to your distributor for quick milk entry
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} md={4} className="text-md-end mt-3 mt-md-0">
                      <Button className="customer-dashboard-qr-btn">
                        <QrCode size={18} />
                        View QR Code
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Recent Orders & Payment Summary */}
          <Row className="mt-4">
            {/* Recent Orders */}
            <Col xs={12} lg={8}>
              <Card className="customer-dashboard-orders-card">
                <Card.Body>
                  <div className="customer-dashboard-card-header">
                    <h3 className="customer-dashboard-card-title">Recent Orders</h3>
                    <a href="#view-all" className="customer-dashboard-view-all-link">
                      View All →
                    </a>
                  </div>
                  <div className="customer-dashboard-table-wrapper">
                    <Table responsive className="customer-dashboard-orders-table">
                      <thead>
                        <tr>
                          <th>Order ID</th>
                          <th>Date</th>
                          <th>Qty</th>
                          <th>Amount</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {recentOrders.map((order, index) => (
                          <tr key={index} style={{ animationDelay: `${index * 0.05}s` }}>
                            <td className="customer-dashboard-order-id">{order.orderId}</td>
                            <td className="customer-dashboard-order-date">{order.date}</td>
                            <td className="customer-dashboard-order-qty">{order.qty}</td>
                            <td className="customer-dashboard-order-amount">{order.amount}</td>
                            <td>
                              <span className="customer-dashboard-status-badge customer-dashboard-status-delivered">
                                <CheckCircle size={14} />
                                {order.status}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Payment Summary */}
            <Col xs={12} lg={4}>
              <Card className="customer-dashboard-payment-card">
                <Card.Body>
                  <h3 className="customer-dashboard-card-title">Payment Summary</h3>
                  
                  <div className="customer-dashboard-payment-items">
                    <div className="customer-dashboard-payment-item">
                      <span className="customer-dashboard-payment-label">Total This Month</span>
                      <span className="customer-dashboard-payment-value customer-dashboard-payment-total">
                        {paymentSummary.totalThisMonth}
                      </span>
                    </div>
                    
                    <div className="customer-dashboard-payment-item">
                      <span className="customer-dashboard-payment-label">Paid</span>
                      <span className="customer-dashboard-payment-value customer-dashboard-payment-paid">
                        {paymentSummary.paid}
                      </span>
                    </div>
                    
                    <div className="customer-dashboard-payment-item">
                      <span className="customer-dashboard-payment-label">Pending</span>
                      <span className="customer-dashboard-payment-value customer-dashboard-payment-pending">
                        {paymentSummary.pending}
                      </span>
                    </div>
                    
                    <div className="customer-dashboard-payment-item customer-dashboard-payment-item-last">
                      <span className="customer-dashboard-payment-label">Last Payment</span>
                      <span className="customer-dashboard-payment-value customer-dashboard-payment-date">
                        {paymentSummary.lastPayment}
                      </span>
                    </div>
                  </div>

                  <Button className="customer-dashboard-pay-btn">
                    <CreditCard size={18} />
                    Pay Now
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
    </MyLayout>
  );
};

export default CustomerDashboard;